<script>
import cloneDeep from 'lodash/cloneDeep'
import {
  memberDetailsComputed,
  memberDetailsMethods,
} from '@state/helpers/member-details'
import { request } from '@/src/services'
import selectItem from './selectItems'

export default {
  props: {
    triggerMask: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      options: cloneDeep(selectItem),
      note: '',
      status: '',
      editable: false,
    }
  },
  computed: {
    ...memberDetailsComputed,
    getDetailsComputed() {
      const details = this.getDetails || null
      if (details) {
        this.setData(details)
      }
      return details
    },
    showNote() {
      const show = cloneDeep(this.getDetailsComputed?.master_member_id)
      if (!show) {
        return true
      } else {
        return false
      }
    },
    optionsComputed() {
      const option = this.options.map((item, index) => {
        if (!index) {
          item.label = ' '
        } else {
          item.label = this.getDetailsComputed?.agent_list[0][`status${index}`]
        }
        return item
      })
      return option
    },
  },
  methods: {
    ...memberDetailsMethods,
    getDetailMember() {
      this.getDetailsById({
        id: this.$route.params.id,
        agent_id: this.$route.params.agent_id,
      })
    },
    setData(details) {
      this.status = cloneDeep(details.agent_list[0].member_status)
      this.note = cloneDeep(details.agent_list[0].admin_note)
    },
    toggleEditable() {
      this.editable = !this.editable
      this.$emit('edit-note', this.editable)
    },
    stopUpdateNote() {
      this.toggleEditable()
      this.setData(this.getDetailsComputed)
    },
    updatedBasicNote() {
      const payload = {
        data: [
          {
            member_id: parseInt(this.$route.params.id),
            status_index: this.status,
            admin_note: this.note,
          },
        ],
        agent_id: this.getDetails?.agent_list[0].agent_id,
      }
      request({
        endpoint: '/cms/member/status_apply/',
        payload: payload,
      }).then(() => {
        this.getDetailMember()
        this.toggleEditable()
      })
    },
  },
}
</script>

<template>
  <div>
    <BaseCardDetail
      v-if="showNote"
      form-collapsed
      title="管理者メモ"
      :trigger-mask="!editable && triggerMask"
      :has-footer="editable"
      @edit="toggleEditable"
      @cancel="stopUpdateNote"
      @submit="updatedBasicNote"
    >
      <CRow>
        <CCol sm="3" class="mt-2">備考</CCol>
        <CCol sm="9">
          <BaseTextarea
            v-model="note"
            :plaintext="!editable"
            :rules="{
              required: false,
              max: 1000,
            }"
          >
          </BaseTextarea>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3" class="mt-2">ステータス</CCol>
        <CCol sm="9">
          <BaseSelect
            :options="optionsComputed"
            :value.sync="status"
            :plaintext="!editable"
            :disabled="!editable"
          />
        </CCol>
      </CRow>
    </BaseCardDetail>
  </div>
</template>
